export const memberTableColumns = [
  {
    type: "select", // Type of data
    label: "Anrede", // Label
    value: "title", // Corresponding key for object
    data: "member", // Belongs to member or contract
    show: false, // If true it will be shown per default on member overview table
  },
  {
    type: "text",
    label: "Nachname",
    value: "lastName",
    show: true, // Will be shown per default on member overview table
    data: "member",
  },
  {
    type: "text",
    label: "Vorname",
    value: "firstName",
    show: true,
    data: "member",
  },
  {
    type: "text",
    label: "Standort",
    value: "standortRef",
    show: true,
    data: "site",
  },
  {
    type: "text",
    label: "Mitglieds-Nr.",
    value: "memberNumber",
    show: true,
    data: "member",
  },
  {
    type: "date",
    label: "Geburtstag",
    value: "birthdate",
    show: true,
    data: "member",
  },
  {
    type: "number",
    label: "Alter",
    value: "age",
    show: true,
    data: "member",
  },
  {
    type: "select",
    label: "Gürtel",
    value: "belt",
    show: true,
    data: "member",
  },
  {
    type: "select",
    label: "Grad",
    value: "degree",
    show: true,
    data: "member",
  },
  {
    type: "date",
    label: "Letzte Prüfung",
    value: "lastTesting",
    show: true,
    data: "member",
  },
  {
    type: "date",
    label: "Vertragsdatum",
    value: "contractDate",
    data: "member",
    show: false,
  },
  {
    type: "date",
    label: "Aktiv seit",
    value: "beginningDate",
    data: "member",
    show: false,
  },
  {
    type: "number",
    label: "Beitrag",
    value: "contribution",
    data: "member",
    show: false,
  },
  {
    type: "string",
    label: "Mitgliedsart",
    value: "memberType",
    data: "member",
    show: false,
  },
  {
    type: "string",
    label: "Status",
    value: "status",
    data: "member",
    show: true,
  },
  {
    type: "date",
    label: "Erstelldatum",
    value: "createdAt",
    data: "member",
    show: false,
  },
];

export const contractTableColumns = [
  {
    type: "text",
    label: "Straße und Nr",
    value: "street",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "PLZ",
    value: "zip",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "Ort",
    value: "city",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "Telefon",
    value: "phoneNumber",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "Mobil",
    value: "mobile",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "E-Mail",
    value: "email",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "Kontoinhaber",
    value: "owner",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "Bank",
    value: "bank",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "IBAN",
    value: "iban",
    data: "contract",
    choosable: false,
  },
  {
    type: "text",
    label: "BIC",
    value: "bic",
    data: "contract",
    choosable: false,
  },
];

export const getDefaultCheckedMemberTableColumns = (columns) => {
  let defC = columns.filter(
    (c) => Object.hasOwn(c, "show") && c?.show === true
  );
  defC = defC.map((col) => col.label);
  return defC;
};

export const moveItemInArray = (arr, index, direction) => {
  const arrayLength = arr.length;

  // Determine the new index for the item
  let newIndex = direction === "up" ? index - 1 : index + 1;

  // Check if the provided index is within valid bounds
  if (index < 0 || index >= arrayLength) {
    console.error("Invalid index");
    return arr;
  }

  var newArray = [...arr];

  // Check if the item is on first or last position
  if (newIndex < 0 || newIndex >= arrayLength) {
    // If item is first and gets pushed up
    if (direction === "up") {
      // Put item on last position
      newArray.push(newArray.shift());
    } else {
      // Put item on first position
      newArray.unshift(newArray.pop());
    }

    return newArray;
  }

  // Swap the items in the array
  [newArray[index], newArray[newIndex]] = [newArray[newIndex], newArray[index]];

  return newArray;
};

export const createNewTableColumns = (columns, selected) => {
  let newColumns = columns.map((c) => {
    // Find corresponding item in memberTableColumns
    // Use object assign and not spread operator because we want to make a shallow copy and not a deep copy
    let newC = Object.assign(
      {},
      memberTableColumns.find((item) => item.label === c)
    );

    // Set show to false for all columns except the ones in checked
    newC.show = false;
    if (selected && selected.length > 0 && selected.includes(c)) {
      newC.show = true;
    }
    return { ...newC };
  });

  return newColumns;
};

export const displayMemberType = (memberType) => {
  return memberType === "adult" ? "Erwachsen" : "Kind";
};
